import React, { useEffect, useState } from 'react';
import styles from './downloading-files-page.module.css';
import LoaderPage from '../../components/LoaderPage/LoaderPage';
import HeaderBack from '../../components/HeaderBack/HeaderBack';

import VideoList from '../../components/VideoList/VideoList';
import { getAllDocuments } from '../../firebase';
import { useDispatch } from 'react-redux';
import { addFilesRedux } from '../../store/slices/filesSlice';
import ImageList from '../../components/ImageList/ImageList';

export default function DownloadingFilesPage() {
  const dispatch = useDispatch();

  const [loaderPage, setLoaderPage] = useState(false);

  useEffect(() => {
    setLoaderPage(true);
    const getDocuments = async () => {
      const allDocuments = await getAllDocuments('files');
      if (allDocuments && allDocuments.length) {
        dispatch(addFilesRedux(allDocuments));
      }
      setLoaderPage(false);
    };
    getDocuments();
  }, []);

  return (
    <>
      {/* -------------- Header ------------------------ */}
      <HeaderBack />
      {/* -------------- /Header ------------------------ */}

      <div className={styles.content_wrapper}>
        <div className={styles.note}>
          <h2 className={styles.title}>Памʼятка користувача</h2>
          <ul className={styles.list}>
            <li>
              <strong>5 ГБ</strong> — безплатно надається для зберігання та загрузки файлів.
            </li>
            <li>
              <strong>1 ГБ на день</strong> — максимальний обсяг безплатного завантаження.
            </li>
          </ul>
        </div>
        <VideoList />
        <ImageList />
      </div>

      {loaderPage && <LoaderPage />}
    </>
  );
}
